import type { FormDataOf } from '../../../../types/templates';
import type { DynamicOptions, SelectOption } from '../../../../types/client-handler';
import { macroSacaTuTarjeta } from '..';
import { getStageInfo, getChannelsWithVariant, getAvailableVariants } from './validation-helpers';

type FormData = FormDataOf<typeof macroSacaTuTarjeta>;

// Filters select options based on current form state. Shows only valid
// combinations to avoid invalid stage/channel/variant tuples.
export const getDynamicOptions = (
  fieldKey: string,
  formData: FormData,
  baseOptionsRaw: DynamicOptions
): SelectOption[] | undefined => {
  const baseOptions = baseOptionsRaw as SelectOption[];
  const currentStage = formData.stage;

  if (fieldKey === 'adChannel') {
    if (!currentStage) return baseOptions;

    const currentVariant = formData.variant;

    if (!currentVariant) {
      const stageInfo = getStageInfo(currentStage);
      return baseOptions.filter(option => (stageInfo.channels as string[]).includes(option.value));
    }

    const channelsWithVariant = getChannelsWithVariant(currentStage, currentVariant);
    return baseOptions.filter(option => channelsWithVariant.includes(option.value));
  }

  if (fieldKey === 'variant') {
    if (!currentStage) return baseOptions;

    const currentChannel = formData.adChannel;

    if (!currentChannel) {
      const stageInfo = getStageInfo(currentStage);
      return baseOptions.filter(option => stageInfo.allVariants.includes(option.value));
    }

    const availableVariants = getAvailableVariants(currentStage, currentChannel);
    return baseOptions.filter(option => availableVariants.includes(option.value));
  }

  return undefined;
};
